import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {ItemTile} from "../../ItemTile";
import * as ReactGA from "react-ga";

const useStyles = makeStyles((theme) => {
    return {
        root: {
            marginLeft: 4
        },
        tile: {
            marginLeft: 4,
        },
        tileMobile: {
            maxWidth: 133,
        },
    }
});

export default function NextCar(props) {

    const classes = useStyles();

    const item = props.nextCar;

    const isMobile = props.isMobile;


    const handleClick = (item, returnRoute) => {
        ReactGA.event({
            category: 'user',
            action: 'next_car'
        });
        props.handleClick(item, returnRoute);
    };

    return (
        <div className={classes.root}>
            <div className={isMobile ? classes.tileMobile: classes.tile}>
                <ItemTile item={item} handleClick={handleClick} returnRoute={props.returnRoute} label="/i/assets/next.png" alt="next"
                micro={props.micro} preload={true} isMobile={true}/>
            </div>
        </div>
    );
}
